import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import Button from '@material-ui/core/Button';
import Warning from '@material-ui/icons/Warning';
import { TextField, Box, Typography } from '@material-ui/core';
import Dialog from './Dialog';
import { Alert } from '@material-ui/lab';
import InputText from './form-input-inline';


class DeleteDialogConfirm extends Component {
    state = {
        comments: "",
        errors: {
            comments: ""
        }
    }

    handleSubmit = () => {
        if (isEmpty(this.state.comments)){
            this.setState({ 
                ...this.state,
                errors:{
                    ...this.state.errors,
                    comments: "Veuillez remplir ce champ"

                }
            })
        } else {
            this.props.handleSubmit(this.state.comments)
        }
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        console.log("[STATE]", this.state);
        return (
            <Dialog 
                disableBackdropClick
                block={true}
                close={this.props.close}
                title={`Supprimer ${this.props.title}`}
                submitAction={this.handleSubmit}
                disabledSubmit={this.props.disabled}
                submitTitle="Supprimer"
            >
                <Box p={1}>
                    <Typography variant="body1">{this.props.text || "Êtes-vous sûr de vouloir supprimer cette opération?"}</Typography>
                </Box>
                <InputText
                    value={this.state.comments}
                    onChange={this.handleChange}
                    required
                    name="comments"
                    error={this.state.errors.comments}
                    label="Motif de la suppression"
                    rows={2}
                />
                <Alert severity="warning">
                    Attention : Cette action sera irréversible
                </Alert>
            </Dialog>
        );
    }
}

export default DeleteDialogConfirm;